export default __webpack_public_path__ + "static/media/community1.9bb7da83.png";